import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-social-network-inprocess-forward.component.ajs';

@Directive({
  selector: 'cng-agent-booking-social-network-inprocess-forward-upgrade',
})
export class AgentBookingSocialNetworkInprocessForwardUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;
  @Input() isConf: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-social-network-inprocess-forward',
  template:
    '<cng-agent-booking-social-network-inprocess-forward-upgrade [responseId]="responseId$ | async" [isConf]="isConf$ | async"></cng-agent-booking-social-network-inprocess-forward-upgrade>',
})
export class AgentBookingSocialNetworkInprocessForwardComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);
  readonly isConf$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.IsConf.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
